<mbs-wizard
  class="mbs-wizard_flex-content"
  [(ngModel)]="stepsManager.currentStep"
  [scrollableStepContent]="true"
  [buttonLoadingMode]="true"
  [canClosed]="!loadingPlan && wizardFinish"
  [firstStepTitle]="mainService.firstStepTitle"
  [isOpenSteps]="!loadingPlan && (isEdit || stepsManager.allStepsVisited)"
  [loading]="loadingPlan"
  [ignoreSteps]="ignorableSteps"
  [stepsOrientation]="orientations"
  [cancelButton]="{ hide: false, text: 'shared:buttons.cancel' | i18next }"
  [saveButton]="{ text: 'shared:buttons.save' | i18next }"
  [stepQueue]="stepsManager.stepQueue"
  [stepsContainerClass]="mainService.isOffline ? 'overflow-hidden' : ''"
  (closeModalEvent)="handleModalClose()"
  (save)="handleSave()"
  (next)="nextHandler($event)"
  (stepSelected)="stepSelectedHandler($event)"
  [title]="wizardTitle + ' ' + mainService.compName + ' | ' + (FormModel?.planNameStep?.Name || '')">
  <div
    *ngIf="mainService.isOffline"
    prependStep
    class="pl-4 py-2 background-secondary">
    <span class="fa fa-power-off"></span> {{ prependStepText }}
  </div>

  <mbs-wizard-step
    [documentationLink]="helpLink.links.welcome"
    [title]="'wizards:welcome' | i18next"
    [valid]="FormModel?.planNameStep?.valid"
    (next)="planNameStep?.forceValid()">
    <mbs-plan-name-step
      #planNameStep
      [(ngModel)]="FormModel.planNameStep"
      (copyPlan)="handleCopyRAWPlan()"
      [planTypeText]="planTypeText"></mbs-plan-name-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.storage"
    [title]="'wizards:whereBackup.where_backup_step_title' | i18next"
    [valid]="FormModel?.whereBackupStep?.valid"
    (next)="whereBackupStep?.forceValid()">
    <mbs-where-backup-step
      #whereBackupStep
      [(ngModel)]="FormModel.whereBackupStep"
      (changeStorage)="storageManager.changeStorageSQLHandler($event)"
      [Storages]="FormModel?.Storages"></mbs-where-backup-step>
  </mbs-wizard-step>

  <!--Here new steps-->
  <mbs-wizard-step
    [documentationLink]="helpLink.links.server"
    [title]="serverInstanceTitle"
    [valid]="FormModel?.sqlServerInstanceStep?.valid"
    (next)="sqlServerInstance?.forceValid(stepsManager.currentStep)">
    <mbs-sql-server-instance-step
      #sqlServerInstance
      [(ngModel)]="FormModel.sqlServerInstanceStep"
      (loadInfo)="loadInfoHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'sqlServerInstanceStep', serverInstanceTitle)"
      [databaseServerInstances]="loadedPlan?.DatabaseServerInstances"></mbs-sql-server-instance-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.data"
    [title]="'wizards:sql:sqlDatabasesMenuTitle' | i18next"
    [valid]="FormModel?.sqlSourceDatabasesStep?.valid"
    (next)="sqlSourceDatabases?.forceValid()">
    <mbs-sql-source-databases-step
      #sqlSourceDatabases
      [(ngModel)]="FormModel.sqlSourceDatabasesStep"></mbs-sql-source-databases-step>
  </mbs-wizard-step>
  <!--End new steps-->

  <mbs-wizard-step
    *ngIf="storageManager.showAdvanced"
    [title]="stepsManager.titles.advancedOptions"
    [valid]="FormModel?.advancedOptionsStep?.valid"
    (next)="advancedOptionsStep?.forceValid(stepsManager.currentStep)">
    <mbs-advanced-options-step
      #advancedOptionsStep
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.advancedOptions"
      [(ngModel)]="FormModel.advancedOptionsStep"
      (changeStorageType)="storageManager.changeAdvancedStorageHandler($event)"
      (nextStep)="forceNextStepWizard(!!$event, 'advancedOptionsStep', stepsManager.titles.advancedOptions)"
      [advancedOptionsFlags]="FormModel?.advancedOptionsFlags"></mbs-advanced-options-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.compressionEncryption"
    [title]="stepsManager.titles.compressionEncryption"
    [valid]="FormModel?.compressionEncryptionStep?.valid"
    (next)="compressionEncryptionStep?.forceValid(stepsManager.currentStep)">
    <mbs-compression-encryption-step
      #compressionEncryptionStep
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.compressionEncryption"
      [isS3Selected]="FormModel?.advancedOptionsFlags?.UseS3AccelerationPossible"
      (nextStep)="forceNextStepWizard(!!$event, 'compressionEncryptionStep', 'Compression & Encryption')"
      [(ngModel)]="FormModel.compressionEncryptionStep"></mbs-compression-encryption-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.retention"
    [title]="stepsManager.titles.retention"
    [valid]="FormModel?.retentionPolicyStep?.valid"
    (next)="retentionPolicyStep?.forceValid()">
    <mbs-retention-policy-step
      #retentionPolicyStep
      [minPeriod]="storageManager.minPeriod"
      [isHybrid]="FormModel.whereBackupStep.IsHybridBackup"
      [(ngModel)]="FormModel.retentionPolicyStep"></mbs-retention-policy-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links.schedule"
    [title]="stepsManager.titles.schedule"
    [valid]="FormModel?.scheduleStep?.valid"
    (next)="scheduleStep?.forceValid(stepsManager.currentStep)">
    <mbs-schedule-step
      #scheduleStep
      [(ngModel)]="FormModel.scheduleStep"
      [stepFocused]="stepsManager.currentStep?.title === stepsManager.titles.schedule"
      (nextStep)="forceNextStepWizard(!!$event, 'scheduleStep', stepsManager.titles.schedule)"
      (changeType)="scheduleTypeChangeHandler($event)"></mbs-schedule-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="!isNBF && FormModel?.scheduleStep?.ScheduleType === 'recurring'"
    [documentationLink]="helpLink.links.schedule"
    [title]="'wizards:advanced_schedule_step_title' | i18next"
    [valid]="FormModel?.scheduleAdvancedStep?.valid"
    (next)="scheduleAdvancedStep?.forceValid()">
    <mbs-schedule-advanced-step
      #scheduleAdvancedStep
      [copyOnly]="FormModel.sqlSourceDatabasesStep.copyOnly"
      [(ngModel)]="FormModel.scheduleAdvancedStep"></mbs-schedule-advanced-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="!isNBF && FormModel?.scheduleStep?.ScheduleType === 'predefined'"
    [documentationLink]="helpLink.links.schedule"
    [title]="'wizards:simple_schedule_title' | i18next"
    [valid]="FormModel?.simpleScheduleStep?.valid"
    (next)="simpleScheduleStep?.forceValid()">
    <mbs-simple-schedule-step
      #simpleScheduleStep
      [copyOnly]="FormModel.sqlSourceDatabasesStep.copyOnly"
      [(ngModel)]="FormModel.simpleScheduleStep"></mbs-simple-schedule-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    [documentationLink]="helpLink.links[(mainService.allowPrePostActions | async) ? 'prepost' : 'chain']"
    [title]="
      (mainService.allowPrePostActions | async) ? ('wizards:pre_post_title' | i18next) : ('wizards:pre_post_title_backup_chain' | i18next)
    "
    [valid]="FormModel?.prePostActionsStep?.valid"
    (next)="prePostActionsStep?.forceValid()">
    <mbs-pre-post-actions-step
      #prePostActionsStep
      [(ngModel)]="FormModel.prePostActionsStep"
      [ChainPlans]="FormModel?.AvailableMachinePlans"></mbs-pre-post-actions-step>
  </mbs-wizard-step>
  <mbs-wizard-step
    *ngIf="!isRDMode"
    [documentationLink]="helpLink.links.log"
    [title]="'wizards:notification_step_title' | i18next"
    [valid]="FormModel?.notificationStep?.valid">
    <mbs-notifications-step
      [(ngModel)]="FormModel.notificationStep"
      (notificationChange)="notificationChangeHandler($event)"
      [notification]="mainService.planNotification"></mbs-notifications-step>
  </mbs-wizard-step>
</mbs-wizard>
